var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowBackMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.820001 7.10206C0.820001 7.32781 0.906194 7.55352 1.07822 7.72563L6.49421 13.1416C6.83874 13.4861 7.39733 13.4861 7.74171 13.1416C8.0861 12.7972 8.0861 12.2387 7.74171 11.8942L2.94934 7.10206L7.74154 2.30994C8.08593 1.96542 8.08593 1.407 7.74154 1.06264C7.39716 0.717951 6.83857 0.717951 6.49405 1.06264L1.07805 6.4785C0.905999 6.65069 0.820001 6.8764 0.820001 7.10206Z",
    fill: "#2B2F32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBackMenu);
export default __webpack_public_path__ + "static/media/ICON_ARROW_BACK_MENU.c815d87d58cac6076753e4e08011b0a3.svg";
export { ForwardRef as ReactComponent };